<template><div><h1>VUX V2.2.2 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Support prop:disabled</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] when replace text of date is empty string, span of date will not show</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix mask closing issue in some situation. #1312</li>
</ul>
<h2><a href="/en/components/range.html">Range</a></h2>
<ul><li>[feature] Support dynamically setting step #1394</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[enhance] Show search text on iOS keyboard</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[fix] fix label:for missing</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Support setting value by labels(beta)</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] Support prop:dialog-style #1282</li>
</ul>
<h2><a href="/en/components/x-header.html">XHeader</a></h2>
<ul><li>[feature] Add slot:overwrite-left</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.2-99.vue?9f15bada